import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decodeHtmlString' })
export class DecodeHtmlStringPipe implements PipeTransform {

    transform(source: number, type: string): any {

        if (type === 'INFINITE') {
            const tempElement = document.createElement('div');
            tempElement.innerHTML = '&#8734;';
            return tempElement.innerText;
        } else {
            return source;
        }
    }

}
